"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInvitationInput = instanceOfInvitationInput;
exports.InvitationInputFromJSON = InvitationInputFromJSON;
exports.InvitationInputFromJSONTyped = InvitationInputFromJSONTyped;
exports.InvitationInputToJSON = InvitationInputToJSON;
/**
 * Check if a given object implements the InvitationInput interface.
 */
function instanceOfInvitationInput(value) {
    if (!('accepted' in value) || value['accepted'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('workspace_id' in value) || value['workspace_id'] === undefined)
        return false;
    return true;
}
function InvitationInputFromJSON(json) {
    return InvitationInputFromJSONTyped(json, false);
}
function InvitationInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accepted': json['accepted'],
        'email': json['email'],
        'workspace_id': json['workspace_id'],
    };
}
function InvitationInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'accepted': value['accepted'],
        'email': value['email'],
        'workspace_id': value['workspace_id'],
    };
}
